import type {
  AdMapVehicleDataFragment,
  AdVehicleFragment,
} from './AdFleetMapVehicles.hook'

export type AdMapVehicle = AdVehicleFragment & AdMapVehicleDataFragment

// typed as a key of the fragment so that dropping the field from
// `AdMapVehicleData` breaks the build instead of silently emptying the map
const mapDataKey: keyof AdMapVehicleDataFragment = 'latestLocation'

export const hasMapData = (
  vehicle: AdVehicleFragment,
): vehicle is AdMapVehicle => mapDataKey in vehicle
